import { useRef, useState, useEffect } from 'react';
import { IonModal, IonButton, IonIcon, IonImg, IonGrid, IonRow, IonCol, IonBadge } from '@ionic/react';
import { calendarOutline, close, chevronForward, chevronBack, bedOutline, airplaneOutline } from 'ionicons/icons';
import { Constants } from '../../../defines/Constants';
import { Storage } from '@capacitor/storage';
import { ShowSwal } from '../../../defines/Functions';
import Swal from 'sweetalert2';
import axios from "axios";
import Loading from '../../Loading';
import moment from 'jalali-moment';
import ProfileOrderAmendment from './ProfileOrderAmendment';
import './ProfileOrder.css';
import basket from '../../../assets/images/dashboard-basket.svg';
import warningSign from '../../../assets/images/warning.svg';
import download from '../../../assets/images/download.svg';

const ProfileOrder = () => {
    const profileOrders = Constants.api.profileOrders;
    const profileOrderMaster = Constants.api.profileOrderMaster;
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        showProfileOrderModal: false,
        token: '',
        pagination: {
            currentPage: 1,
            pageCount: 0,
            perPage: 10,
            totalCount: 0
        },
        orders: []
    });
    const userDataRef = useRef(false);
    const getUserData = async () => {
        if (!userDataRef.current) {
            const { value } = await Storage.get({ key: 'userData' });
            if (value) {
                const objectValue = JSON.parse(value);
                setState({ ...state, token: objectValue.token });
            } else {
                return false;
            }
        }
        userDataRef.current = true;
    }
    getUserData();
    const getOrders = async (page: number, perPage: number) => {
        setLoading(true);
        try {
            const orderResults = await axios.get(profileOrders + '?page=' + page + '&per-page=' + perPage, {
                headers: {
                    Authorization: 'Bearer ' + state.token
                }
            });
            if (orderResults.status === 200) {
                setState(prevState => ({
                    ...prevState,
                    orders: orderResults.data.items,
                    pagination: {
                        currentPage: orderResults.data._meta.currentPage,
                        pageCount: orderResults.data._meta.pageCount,
                        perPage: orderResults.data._meta.perPage,
                        totalCount: orderResults.data._meta.totalCount
                    }
                }));
                setLoading(false);
            }
        } catch (error: any) {
            console.log(error);
            setLoading(false);
        }
    }
    useEffect(() => {
        if (state.showProfileOrderModal) {
            getOrders(1, 10);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.showProfileOrderModal]);
    const nextPage = () => {
        getOrders(state.pagination.currentPage + 1, 10);
        setState({ ...state, pagination: { ...state.pagination, currentPage: state.pagination.currentPage + 1 } });
    }
    const prevPage = () => {
        getOrders(state.pagination.currentPage - 1, 10);
        setState({ ...state, pagination: { ...state.pagination, currentPage: state.pagination.currentPage - 1 } });
    }
    const configApi = Constants.api.config;
    const [phone, setPhone] = useState('');
    useEffect(() => {
        const getConfig = async () => {
            try {
                const results = await axios.get(configApi);
                if (results.data.status === 'success') {
                    await Storage.set({
                        key: 'config',
                        value: JSON.stringify(results.data.config_items[0]),
                    });
                    setPhone(results.data.config_items[0].contact_phone);
                }
            } catch (error: any) {
                console.log(error);
            }
        }
        getConfig();
    }, [configApi]);
    const downloadPdf = async (contractId: any, trackCode: any) => {
        setLoading(true);
        let lang = '';
        var xmlData = '<OTA_ReadRQ><UniqueID ID="' + contractId + '" /></OTA_ReadRQ>';
        try {
            const amendmentResults = await axios.post(profileOrderMaster, xmlData, {
                headers: {
                    Authorization: 'Bearer ' + state.token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (amendmentResults.data.status === 'success') {
                if (
                    amendmentResults.data.items.reservationsList.airReservation[0].tpaextensions.any[0].departureCountry !== 'IR' ||
                    amendmentResults.data.items.reservationsList.airReservation[0].tpaextensions.any[0].arrivalCountry !== 'IR'
                ) {
                    lang = 'en';
                } else {
                    lang = 'fa';
                }
            }
            setLoading(false);
        } catch (error: any) {
            console.log(error);
            setLoading(false);
        }
        const swalOptions = {
            title: 'دانلود فایل pdf بلیط',
            iconHtml: '<img src="' + download + '" width="40" style="margin-bottom: 10px;" />',
            html: '<span>شماره پشتیبانی : <a href="tel:' + phone + '" style="display: inline-block;direction: ltr;color: #333D79;text-decoration: none;">' + phone + '</a></span>',
            customClass: {
                container: 'downloadSwal'
            },
            backdrop: false,
            allowOutsideClick: false,
            showConfirmButton: true,
            confirmButtonText: 'دانلود',
            confirmButtonColor: '#333D79',
            showDenyButton: true,
            denyButtonText: 'بستن',
            denyButtonColor: '#F1C400',
            isConfirmed: () => {
                const ticketLink = Constants.domain + '/pdf/index.php?tc=' + trackCode + '&l=' + lang;
                window.open(ticketLink, '_blank');
            },
            isDenied: () => Swal.close()
        }
        ShowSwal(swalOptions);
    }
    return (
        <>
            <IonModal isOpen={state.showProfileOrderModal} onDidDismiss={() => setState({ ...state, showProfileOrderModal: false })} mode="ios" cssClass="profile-order-modal">
                <div className="profile-order-modal-content">
                    <h3 className="profile-order-modal-title">
                        لیست خرید ها
                        <IonIcon icon={close} onClick={() => setState({ ...state, showProfileOrderModal: false })} />
                    </h3>
                    <div className="profile-order-modal-items">
                        {!loading ?
                            <>
                                {state.orders.length === 0 ?
                                    <div className="box-error">
                                        <IonImg src={warningSign} />
                                        <p>در حال حاضر هیچ خریدی ثبت نشده است</p>
                                    </div>
                                    :
                                    <>
                                        {state.orders.map((item: any, index: number) =>
                                            <div className="order-box" key={"index" + index}>
                                                <IonGrid>
                                                    <IonRow>
                                                        <IonCol size="4">
                                                            <b>شماره رزرو</b>
                                                            <span>{item.contract_id}</span>
                                                        </IonCol>
                                                        <IonCol size="4">
                                                            <b>وضعیت</b>
                                                            {item.status === 'paid' ?
                                                                <IonBadge color="success">صادر شده</IonBadge>
                                                                :
                                                                <IonBadge color="danger">صادر نشده</IonBadge>
                                                            }
                                                        </IonCol>
                                                        <IonCol size="4">
                                                            <b>نوع خرید</b>
                                                            {item.type === 'flight' ?
                                                                <span>
                                                                    <IonIcon icon={airplaneOutline} />
                                                                    رزرو پرواز
                                                                </span>
                                                                :
                                                                <span>
                                                                    <IonIcon icon={bedOutline} />
                                                                    رزرو هتل
                                                                </span>
                                                            }
                                                        </IonCol>
                                                        <IonCol size="12">
                                                            <b>تاریخ خرید</b>
                                                            <span>
                                                                <IonIcon icon={calendarOutline} />
                                                                {moment(item.created).locale('fa').format('dddd DD MMMM YYYY ساعت h:mm:ss')}
                                                            </span>
                                                        </IonCol>
                                                        <IonCol size="6">
                                                            <IonButton color="warning" expand="block" onClick={() => downloadPdf(item.contract_id, item.track_code)}>
                                                                مشاهده بلیط
                                                            </IonButton>
                                                        </IonCol>
                                                        <IonCol size="6">
                                                            <ProfileOrderAmendment data={item} type={item.type} />
                                                        </IonCol>
                                                    </IonRow>
                                                </IonGrid>
                                            </div>
                                        )}
                                        <div className="my-custom-pagination">
                                            <span>صفحه {state.pagination.currentPage} از {state.pagination.pageCount}</span>
                                            {state.pagination.pageCount > 1 &&
                                                <ul>
                                                    <li onClick={prevPage} className={state.pagination.currentPage === 1 ? 'disabled' : ''}>
                                                        <IonIcon icon={chevronForward} />
                                                    </li>
                                                    <li onClick={nextPage} className={state.pagination.currentPage === state.pagination.pageCount ? 'disabled' : ''}>
                                                        <IonIcon icon={chevronBack} />
                                                    </li>
                                                </ul>
                                            }
                                        </div>
                                    </>
                                }
                            </>
                            :
                            <Loading />
                        }
                    </div>
                </div>
            </IonModal>
            <div className="dashboard-box" onClick={() => setState({ ...state, showProfileOrderModal: true })}>
                <div>
                    <IonImg src={basket} />
                </div>
                <div>
                    <b>لیست خرید ها</b>
                </div>
            </div>
        </>
    );
};
export default ProfileOrder;